import React from 'react';
//import Users from './Users';
import { Link } from 'react-router-dom';

const UserItems = (props) => {
  const { avatar_url, login } = props.user;
  //console.log(props.user);
  return (
    <div className='card text-center'>
      <img
        src={avatar_url}
        alt=''
        className='round-img'
        style={{ width: '60px' }}
      />
      <h2>{login}</h2>
      <div>
        <Link to={`/user/${login}`} alt=''>
          {' '}
          Profile
        </Link>
      </div>
      {/* <div>userItems</div>
        <h1>Hello for me</h1> */}
    </div>
  );
};

export default UserItems;
